import {
    addClassForCloseAnimation,
    convertCssAniDurationToMS
} from "../utilities/helper-function";

class CountrySelect {
    constructor(element) {
        this.element = element;
        this.closeBtn = this.element.querySelector('.country-select__close-btn');
        this.rootStyles = getComputedStyle(document.documentElement);
        this.aniFast= convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--fast').trim());
        this.elementHeight = this.element.getBoundingClientRect().bottom;

        this.closeBtn.addEventListener('click', () => this.fadeOutElement());
    }

    fadeOutElement() {
        this.element.classList.remove("country-select--show");
        addClassForCloseAnimation(this.element, "country-select--fade-out", this.aniFast)
    }
}

export default CountrySelect;